import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonState } from '@utils/types';

const initialState: CommonState = {
  loading: false,
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setIsLoading } = commonSlice.actions;

export default commonSlice.reducer;
